var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3107 1.5H5.68934L1.5 5.68934V12.3107L5.68934 16.5H12.3107L16.5 12.3107V5.68934L12.3107 1.5ZM6.2623 3.04836L4.06066 5.25H5.16148L6.2623 3.04836ZM3 6.75V11.25H4.5V6.75H3ZM4.06066 12.75L6.26228 14.9516L5.16147 12.75H4.06066ZM7.96352 15H8.25V12.75H6.83852L7.96352 15ZM9.75 15H10.0365L11.1615 12.75H9.75V15ZM11.7377 14.9516L13.9393 12.75H12.8385L11.7377 14.9516ZM15 11.25V6.75H13.5V11.25H15ZM13.9393 5.25L11.7377 3.04836L12.8385 5.25H13.9393ZM10.0365 3H9.75V5.25H11.1615L10.0365 3ZM8.25 3H7.96353L6.83853 5.25H8.25V3ZM12 11.073L11.9115 11.25H9.75V6.75H11.9115L12 6.92706V11.073ZM6.08853 6.75L6 6.92706V11.073L6.08852 11.25H8.25V6.75H6.08853Z",
    fill: "black",
    fillOpacity: 0.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left_icon.d355098e6cd2318633cc76833be7a95d.svg";
export { ForwardRef as ReactComponent };